import { StoreProductGroupMemberDetails } from "@/chipply/StoreProductGroupMemberDetailModel";
import ProductColorSizeWrapperModel from "@/chipply/ProductColorSizeWrapperModel";
import RadioButtonModel from "@/chipply/RadioButtonModel";
import CartItemViewModel from "./view-model/CartItemViewModel";

export class StoreProductGroupDetails {
    public storeProductGroupParentId = 0;
    public storeProductGroupName = "";
    public storeProductGroupMinQuantity = 0;
    public storeProductGroupMaxQuantity = 0;
    public storeProductGroupImageUrl = "";
    public storeProductGroupPreviewImageUrl = "";
    public groupMemberModels: StoreProductGroupMemberDetails[] = [];
    public groupMemberCountInCart = 0;
    public selectedGroupProduct: StoreProductGroupMemberDetails | null = null;

    constructor(productGroupDetails: StoreProductGroupDetails) {
        this.storeProductGroupParentId = productGroupDetails.storeProductGroupParentId;
        this.storeProductGroupName = productGroupDetails.storeProductGroupName;
        this.storeProductGroupMinQuantity = productGroupDetails.storeProductGroupMinQuantity;
        this.storeProductGroupMaxQuantity = productGroupDetails.storeProductGroupMaxQuantity;
        this.storeProductGroupImageUrl = productGroupDetails.storeProductGroupImageUrl;
        this.storeProductGroupPreviewImageUrl = productGroupDetails.storeProductGroupPreviewImageUrl;
        for (const model of productGroupDetails.groupMemberModels) {
            if (model.enabled) {
                this.groupMemberModels.push(new StoreProductGroupMemberDetails(model));
            }
        }
    }

    public setProductSelected(productId: number) {
        for (const model of this.groupMemberModels) {
            if (model.productId === productId || model.relatedProcessProductIds.includes(productId)) {
                model.isSelected = true;
                this.selectedGroupProduct = model;
            } else model.isSelected = false;
        }
    }

    public setProductsInCart(cartContents: CartItemViewModel[]) {
        for (const model of this.groupMemberModels) {
            for (const cartItem of cartContents) {
                if (
                    model.productId === cartItem.eventProductId ||
                    model.relatedProcessProductIds.includes(cartItem.eventProductId)
                ) {
                    model.isInCart = true;
                    this.groupMemberCountInCart += cartItem.itemQuantity;
                }
            }
        }
    }

    public addRelatedProcessProductIds(productIdToFind: number, designs: RadioButtonModel[]) {
        const relatedProcessProducts = designs.filter((design) => design.value !== productIdToFind);
        const productIdsToAdd = relatedProcessProducts.map((product) => product.value);
        const groupProduct = this.groupMemberModels.find((model) => model.productId === productIdToFind);
        if (groupProduct) {
            for (const id of productIdsToAdd) {
                if (!groupProduct.relatedProcessProductIds.includes(id)) {
                    groupProduct.relatedProcessProductIds.push(id);
                }
            }
        }
    }
}
